/* eslint-disable max-lines-per-function */
import { Form, Formik } from "formik";
import React from "react";
import * as yup from "yup";
import { Grid, Typography } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Card } from "components/haven-design/card";
import { LoneGrid, BackToLogin, LoginCardTitle } from "components/login/components/shared-components";
import { requestResetPasswordEmail } from "./actions";
import { loginStyles } from "./styles";

type Props = {
  location: {
    state: {
      email?: string;
      requestedPath?: string;
    } | null;
  };
};

const ResetPasswordText: React.FC = () => (
  <LoneGrid>
    <Typography variant="subtitle1" style={{ textAlign: "center" }}>
      Enter your email address to reset password
    </Typography>
    <br/>
  </LoneGrid>);

const ResetPassword: React.FC<RouteComponentProps<Props>> = ({ location }) => (
  <Grid container justifyContent="center" spacing={2} direction="row">
    <Grid item xs={12}> <br /> </Grid>
    <Grid
      item
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Card style={loginStyles.card}>
        <div style={loginStyles.textContainer}>
          <Grid item>
            <LoginCardTitle title="Reset Password" />
          </Grid>
          <Grid item>
            <ResetPasswordText />
          </Grid>
          <Grid item>
            <Formik
              initialValues={{ email: location?.state?.email || "" }}
              onSubmit={({ email }) => {
                requestResetPasswordEmail({ email: email.trim().toLowerCase() });
                if (location?.state?.requestedPath) {
                  localStorage.setItem("requestedPath", location?.state.requestedPath);
                }
              }}
              validationSchema={yup.object().shape({
                email: yup.string().required(),
              })}
            >
              <Form>
                <Grid item xs={12}>
                  <InputWithErrorLabel
                    name="email"
                    label="Email"
                    type="text"
                  />
                </Grid>

                <LoneGrid>
                  <Button color="primary" size="L" type="submit" style={loginStyles.btn}>
                  Send Instructions
                  </Button>
                </LoneGrid>

                <BackToLogin />
              </Form>
            </Formik>
          </Grid>
        </div>
      </Card>
    </Grid>
    <Grid item xs={12}>
      <div style={{ height: "5em" }}/>
    </Grid>
  </Grid>
);

export default ResetPassword;
